import { RuleAddQuestionTypeContainer } from './RuleAddQuestionTypeContainer';
export default RuleAddQuestionTypeContainer;
